<!--
 * @Author: lan.h
 * @Date: 2022-02-24 10:21:33
 * @LastEditors:  
 * @LastEditTime: 2022-05-17 15:47:08
 * @Description: 报告图表弹窗 
-->
<template>
  <div class="report-modal">
    <Modal
        v-model="isReportModal"
        class="report-mode"
        :title="detail.fileName ? detail.fileName : ' '"
        :footer-hide="true"
        :width="632"
        @on-cancel="cancel">
        <div class="desc">
          <p class="over-p1"><span>图片来源：</span>{{detail.reportTitle}}</p>
          <a @click="toReport()">查看报告</a>
        </div>
        <div class="content">
          <img class="img" v-if="detail.reportType == 0" :src="detail.filePath | logo_show('/report_type_img')"  :preview="preview" :large="detail.filePath | logo_show('/report_type_img')">
          <img v-else class="img" :src="detail.filePath | logo_show('/report_image')"  :preview="preview" :large="detail.filePath | logo_show('/report_image')">
          <a @click="handleDownloadQrIMg">下载无水印图片</a>
        </div>
        <div v-show="relation.length > 0">
          <div class="relation">
          <div class="title">相关图表</div>
          <ul>
            <li v-for="item,index in relation" :key="index" @click="handReport(item)">
              <div>
                <img v-if="item.reportType == 0" class="logo" :src="item.filePath | logo_show('/report_type_img')">
                <img v-else class="logo" :src="item.filePath | logo_show('/report_image')">
              </div>
              <p class="over-p2">{{item.fileName}}</p>
            </li>
          </ul>
        </div>
        <div class="flash-more" v-show="relation.length > 0" @click="more">
          <a>查看更多</a>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
import { getChartDownloadVerification, getChartReportDetails, getReportChartList } from '../../service'
export default {
  inject: ['haddleApplyTry'],
  props: {
    isReportModal: {
      default: false
    },
    detail: {
      default: {}
    },
    relation: {
      default: []
    },
    preview: {
      default: "1"
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    async handReport(item) {
      this.detail = {...item}
      let res = await getReportChartList( {
        file_id: this.detail.id,
        app_layer_tag: this.detail.reportTag,
        name: '',
        page: 1,
        size: 3
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.relation = res.data.records
      } else {
        this.$Message.error(res.msg)
      }
    },
    async handleDownloadQrIMg() {
      let res = await getChartDownloadVerification( {
        user_key: this.$store.state.user_key,
        chart_id: this.detail.id,
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if( res.code == 0){
        let alink = document.createElement("a");
        alink.href = this.$store.state.img_req_url + this.detail.filePath
        alink.download  = this.detail.fileName
        alink.target = '_blank'
        alink.click();
      }
      else if (res.code == -1) {
        this.haddleApplyTry('温馨提示', '报告图表无水印下载动脉橙机构版无限制，欢迎试用动脉橙机构版。', 21)
      }
      else{
        this.$Message.error(res.msg)
      }
    },
    cancel() {
      this.$emit('closeModal')
    },
    async toReport() {
      let res = await getChartReportDetails( {
        user_key: this.$store.state.user_key,
        report_uid: this.detail.reportUid,
      }, (error) => {
        this.$Message.error('请求错误！')
      })
      if( res.code == 0){
        const href = this.$store.state.index_path + '/reportDetail/' + this.detail.reportUid
        window.open(href, '_blank')
      }
      else if (res.code == -1) {
        this.haddleApplyTry('温馨提示', '查看报告源动脉橙机构版无限制，欢迎试用动脉橙机构版。', 22)
      }
    },
    more() {
      const href = this.$store.state.index_path + '/chartSet'
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="stylus" scoped>
ellipsisClamp()
  display -webkit-box
  overflow hidden
  text-overflow ellipsis
  word-break break-all
  -webkit-box-orient vertical
// 超出显示省略号
for num in 1 .. 9
  >>>.over-p{num}
    ellipsisClamp()
    -webkit-line-clamp num
.report-mode
  >>>.ivu-modal-wrap
    display: flex;
    justify-content: center;
    align-items: center;
    .ivu-modal
      top auto
      .ivu-modal-content
        border-radius 0
        padding-bottom 40px
        .ivu-modal-close
          top 14px
          i 
            color #ccc
        .ivu-modal-header
          border-bottom 0
          padding 20px 20px 20px
          .ivu-modal-header-inner
            font-size 16px
            font-weight bold
            color #333333
        .ivu-modal-body
          padding 0 20px 0
          max-height calc(100vh - 140px)
          overflow-y auto
          &::-webkit-scrollbar
            width 8px
          &::-webkit-scrollbar-thumb 
            background #ffdfaf
          .content
            width 100%
            background #F8F9FA
            padding 12px
            display flex
            flex-wrap wrap
            justify-content center
            margin-top 16px
            .img
              max-width 532px
              max-height 300px
              cursor pointer
            a 
              text-align center
              display block
              font-size 14px
              color #FA5A00
              width 100%
              margin-top 10px
              cursor pointer
              &:hover
                color #FF4800
          .desc
            display flex 
            font-size 14px
            font-weight 500
            margin-top 10px
            p 
              flex 1
              color #333
              span 
                color #999
            a 
              color #FA5A00
              display block
              padding-left 30px
              &:hover 
                color #FF4800
          .relation
            margin-top 30px
            .title
              font-size 16px
              font-weight bold
              color #333333
            ul 
              margin-top 15px
              display flex
              justify-content space-between
              li 
                width 184px
                cursor pointer
                div
                  width 184px
                  height 136px
                  overflow hidden
                  background #fff
                  display flex 
                  justify-content center 
                  align-items center
                  img
                    max-width 100%
                    max-height 100%
                    &:hover
                      transform scale(1.1)
                      transition all 0.6s ease 0s
                p 
                  margin-top 15px
                  font-size 14px
                  font-weight 500
                  color #333333
                  line-height 20px
                  word-break break-all
          .flash-more
            margin-top 20px
            height 36px
            border 1px solid #FA5A00
            width 100%
            font-size 14px
            font-weight 500
            line-height 36px
            text-align center
            cursor pointer
            a 
              color #FA5A00
            &:hover
              a 
                color #FF4800

</style>